import { createTheme } from "./theme/create-theme";

const theme = createTheme();

export default theme;